// Estado de UI LOCAL do módulo — não entra no doc e não é desfazível.
//
// Hoje só existe por um motivo: COORDENAR os dois pontos de upload. Canvas (empty
// state) e Inspector (campo "Imagem") montam, cada um, seu próprio `ImageUploader`
// (ver o comentário no topo de `ImageUploader.tsx`) — e os dois consomem o MESMO
// `MetaContext` do EditorProvider, porque o shell renderiza `<module.Canvas />` e
// `<module.Inspector />` como irmãos dentro do mesmo provider. É esse contexto
// compartilhado (não a extração do componente) que permite avisar um lado do que o
// outro está fazendo — mesmo mecanismo que o caça-palavras já usa em
// `wordsearch/ui.ts` para `selectedRef`/`dragStart`.

export interface RebusUi {
  /** true enquanto HÁ um upload em andamento — não importa qual dos dois pontos
   *  (Canvas ou Inspector) o iniciou. O outro ponto lê isto para recusar iniciar um
   *  segundo upload concorrente para o mesmo `idJogo`. */
  uploading: boolean;
}

export function initialRebusUi(): RebusUi {
  return { uploading: false };
}
